module.exports = __webpack_public_path__ + "static/media/tiktok.f658036d.svg";